import { useEffect, useRef } from 'react';
import type { TrackingEvent } from '@/@types/trackingEvent';
import type { TrackingData } from '@/tracking/tracking';
import { reportEvent } from '@/tracking/tracking';

/** Reports one visit per mount, including during Strict Mode effect replay. */
export const useReportPageVisit = (event: TrackingEvent, data: TrackingData) => {
  const reported = useRef(false);

  useEffect(() => {
    if (reported.current) {
      return;
    }
    reportEvent(event, data);
    reported.current = true;
  }, [event, data]);
};
